import { createContext, useEffect, useState } from "react";

export const WindowContext = createContext();

export const WindowContextProvider = ({ children }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <WindowContext.Provider
      value={{
        windowWidth,
        small: windowWidth <= 800,
        medium: windowWidth > 800 && windowWidth <= 1300,
        large: windowWidth > 1300,
      }}
    >
      {children}
    </WindowContext.Provider>
  );
};
